import { type Routes } from '@angular/router';

import { authGuard, guestGuard } from '@core/auth';
import { unknownRouteGuard } from '@core/nav';

export const routes: Routes = [
  {
    path: 'login',
    canMatch: [guestGuard],
    loadChildren: () => import('./features/login/auth.routes').then((m) => m.authRoutes),
  },
  /**
   * TEMP-REMOVE: Internal component gallery.
   * Delete this route and `src/app/features/test-examples/` when the gallery is retired.
   * Keep `canMatch: [authGuard]` until then so the page is never public.
   */
  {
    path: 'test-examples',
    canMatch: [authGuard],
    loadComponent: () =>
      import('./features/test-examples/test-examples.page').then((m) => m.TestExamplesPage),
  },
  {
    path: '',
    canMatch: [authGuard],
    loadChildren: () => import('./features/shell/shell.routes').then((m) => m.shellRoutes),
  },
  /**
   * TEMP-REMOVE: The under-construction `loadComponent` is only a router stub.
   * Replace it with a real not-found page, or drop the component once unused.
   */
  {
    path: '**',
    canActivate: [unknownRouteGuard],
    loadComponent: () =>
      import('./features/under-construction/under-construction.page').then(
        (m) => m.UnderConstructionPage,
      ),
  },
];
